"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var MainContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  height: 20px;\n  box-sizing: border-box;\n  border-radius: 2px;\n  margin-left: auto;\n  white-space: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n\n  & > p {\n    font-family: ", ";\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 19px;\n    color: ", ";\n    background-color: ", ";\n    padding: 1px 3px;\n    border-radius: 3px;\n    min-width: 50px;\n    height: 21px;\n    text-align: center;\n  }\n  border: ", ";\n  ::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n  }\n  ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: #d4d1d7;\n    border-radius: 3px;\n  }\n"])), _variables.FontFamily.AvenirNext, _variables.GlobalColors.s5, _variables.GlobalColors.s2, function (props) {
  return props.error && "1px solid red";
});

exports.MainContainer = MainContainer;